import { Check } from "lucide-react";

export const RAIL_META = {
  razorpay: { label: "Razorpay", color: "#4285F4" },
  phonepe: { label: "PhonePe", color: "#B48CF2" },
};

export function PhonePeBadge({ className = "", size = 14 }) {
  return (
    <span data-testid="phonepe-badge" title="PhonePe"
          className={`inline-flex items-center justify-center rounded-[3px] bg-[#5F259F] text-white font-black leading-none select-none shadow-[0_0_0_1px_rgba(216,178,62,0.35)] ${className}`}
          style={{ width: size, height: size, fontSize: Math.round(size * 0.62) }}>
      पे
    </span>
  );
}

export function RailChip({ rail, className = "" }) {
  const m = RAIL_META[rail] || RAIL_META.razorpay;
  return (
    <span data-testid={`rail-chip-${rail}`}
          className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 font-grotesk text-[9px] uppercase tracking-[0.2em] ${className}`}
          style={{ borderColor: `${m.color}66`, color: m.color, background: `${m.color}14` }}>
      {rail === "phonepe" && <PhonePeBadge size={11} />} {m.label}
    </span>
  );
}

export function RailSelector({ value, onChange, label = "Payment Rail", testId = "rail-selector", compact = false, disabled = false }) {
  return (
    <div data-testid={testId} className={compact ? "inline-flex flex-col gap-1" : "space-y-1.5"}>
      {label && <div className="font-grotesk text-[9px] uppercase tracking-[0.26em] text-[#D8B23E]">{label}</div>}
      <div className="inline-flex border border-[#D8B23E]/40 rounded-sm overflow-hidden" role="radiogroup">
        {["razorpay", "phonepe"].map((r, i) => {
          const on = value === r;
          const m = RAIL_META[r];
          return (
            <button key={r} type="button" role="radio" aria-checked={on} disabled={disabled}
                    data-testid={`${testId}-${r}`} onClick={() => onChange(r)}
                    className={`inline-flex items-center gap-2 ${compact ? "px-3 py-1.5" : "px-4 py-2.5"} font-grotesk text-[10px] uppercase tracking-[0.22em] transition-colors duration-200 ${
                      i === 0 ? "border-r border-[#D8B23E]/20" : ""} ${on ? "bg-[#D8B23E] text-black" : "text-[#C9C9C2] hover:bg-white/5"} disabled:opacity-50`}>
              {on && <Check size={11} />}
              {r === "phonepe" && <PhonePeBadge size={12} className={on ? "" : "opacity-90"} />}
              {i + 1}. {m.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
